import React, { useEffect, useState } from 'react'
import DetilnImg from '../pageStructure/DetilnImg';
import LowerLeft from './LowerLeft';
import LowerRight from './LowerRight';
import axios from 'axios';
import useGetFacultyImages from '../../hooks/useGetFacultyImages';



  
  const facultyPage={
    heading:'Faculty of Topography & Geographic Information Systems',
    content:['The faculty conducts training programs in Topographical Survey and Geographic Information Systems with the objective of enhancing institutional and professional capacity.',' The programmes deliver foundational theoretical knowledge to course participants, which is reinforced through advanced, hands-on lab demonstrations.','The training programmes aim at inculcating and exposing the trainees to the industry best practices and software/s .Both online as well as offline courses are conducted to cater to the wide variety of participants from Departmental, other governmental and private agencies.',' The faculty comprises well-trained professionals with practical experience in both conventional and modern technologies in the fields of Digital Mapping and GIS."']
  }
const FacultyCarto = () => {
    const [faculty,setFaculty] = useState(null)
    const [headData, setHeadData] = useState(null);

    const facultyImages = useGetFacultyImages('Faculty_Topo&GIS');

    const getFacultyMember = async ()=>{
    try {
      const url = "https://api.nigst.surveyofindia.gov.in/admin/faculty_member_faculty1/Faculty_Topo&GIS";
      const res = await axios.get(url);
      setFaculty(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
    const getHeadFaculty = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/sadmin/view_admin`;
      const res = await axios.get(url);
      const headData = res.data.admins.find(item => item.faculty === 'Faculty_Topo&GIS');
      setHeadData(headData);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getFacultyMember();
    getHeadFaculty();
  }, [])
  return (
<div className='m-2 md:m-4 p-2 md:p-6'>
    <DetilnImg heading={facultyPage.heading} text={facultyPage.content} images={facultyImages} />

    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  m-4 md:m-6 lg:m-8 rounded-md gap-2 md:gap-4 lg:gap-6'>
    
      <LowerLeft  headData={headData} />
      <LowerRight data={faculty} />
    </div>
    </div>

      )
}

export default FacultyCarto